/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SiteNavDropdownImageModule_navigationModule$ref = any;
export type SiteNavDropdownContent_navigationModule$ref = any;
export type SiteNavDropdownContent_navigationModule = {
    readonly imageUrl: string | null;
    readonly " $fragmentRefs": SiteNavDropdownImageModule_navigationModule$ref;
    readonly " $refType": SiteNavDropdownContent_navigationModule$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SiteNavDropdownContent_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownImageModule_navigationModule",
      "args": null
    }
  ]
};
(node as any).hash = '1b494936a181d3695e6f453d32225b08';
export default node;
